import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DBService } from '../../../service/DB.service';
import { signOut } from "aws-amplify/auth";

@Component({
    template: ``,
    standalone: false
})
export class UserSignOutComponent implements OnInit {

  constructor(private dbService: DBService, private router: Router) { }

  ngOnInit(): void {
    this.recordLogoutData();
    signOut();
    this.router.navigate(['extra-layout/home']);
  }

  recordLogoutData() {
    console.log('Attempting to record login');
    sessionStorage.removeItem('xyz');
    sessionStorage.removeItem('login-data');
    sessionStorage.removeItem('analysis-data');
    this.dbService.recordAuthEvent('logout').subscribe((data: string) => {
//       console.log('RECORDED LOGOUT DATA', data);
    });
  }
}
